export default __webpack_public_path__ + "static/media/twitterlogo.85bcc6f9.png";